import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import {toast} from "react-toastify";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { FaRegEye, FaEyeSlash } from "react-icons/fa";
import classes from "../../Styles/common.module.css";
import BackModal from '../BasicElements/BackModal';
import ConfirmModal from '../BasicElements/ConfirmModal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const ProfileChangePassword = (props) => {
  const userEmailInputRef = useRef();
  const userPasswordInputRef = useRef();
  const userCPasswordInputRef = useRef();
  const [hasChanges, setHasChanges] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [newVisible, setNewVisible] = useState(false);

	const toggleNewPasswordVisibility = () => {
		setNewVisible(!newVisible);
	};

  const [reVisible, setReVisible] = useState(false);

	const toggleRePasswordVisibility = () => {
		setReVisible(!reVisible);
	};

  const [curVisible, setCurVisible] = useState(false);

	const toggleCurPasswordVisibility = () => {
		setCurVisible(!curVisible);
	};

  const onKeyDown = (event) => { 
		if (event.key === "Enter") 
      setShowConfirmModal(true);
	};

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);

  useEffect(() => {
    if (props.editData !== null) {
      setEditData({
        USER_ID: props.editData.USER_ID === null ? "" : props.editData.USER_ID,
        USERNAME: props.editData.USERNAME === null ? "" : props.editData.USERNAME,
        EMAIL: props.editData.EMAIL === null ? "" : props.editData.EMAIL,
        ERROR_MSG: props.editData.ERROR_MSG === null ? "" : props.editData.ERROR_MSG,
      });
    }
  }, [props.editData]);

  const hideModal = () => {
    setEditData([]);
    setInputError([]);
    props.onHide();
  };

  const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
		var flag = true;
    if (editData.PASSWORD === undefined) {
			flag = false;
      setInputError((prevState) => ({
        ...prevState,
        PASSWORD: ("Password could not be empty."),
      }));
    } else {
      furtherValidateInput("PASSWORD", editData.PASSWORD)
    }
    if (editData.CONFIRM_PASSWORD === undefined) {
			flag = false;
      setInputError((prevState) => ({
        ...prevState,
        CONFIRM_PASSWORD: ("Confirm Password could not be empty."),
      }));
    } else {
      furtherValidateInput("CONFIRM_PASSWORD", editData.CONFIRM_PASSWORD)
    }
    if (editData.CURRENT_PASSWORD === undefined) {
			flag = false;
      setInputError((prevState) => ({
        ...prevState,
        CURRENT_PASSWORD: ("Current Password could not be empty."),
      }));
    }
    if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
      setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    ChangePassword();
    setShowConfirmModal(false); // Hide confirm modal
  };

  const handleConfirmModalClose = () => {
      setShowConfirmModal(false); // Hide confirm modal on cancel
  };

  function ChangePassword() {
    if (editData.PASSWORD !== undefined && editData.CONFIRM_PASSWORD !== undefined && editData.CURRENT_PASSWORD !== undefined) {
      let functionName = "";
      try {
        functionName = ChangePassword.name;
        props.onLoading(true, "Changing password, please wait...");
        var curEncrypted = common.c_EncryptData(editData.CURRENT_PASSWORD.trim());
        var encrypted = common.c_EncryptData(editData.PASSWORD.trim());
        const data = {
          USER_MST_GUID: editData.USER_ID,
          USER_NAME: editData.USER_NAME,
          EMAIL: editData.EMAIL,
          CURRENT_PASSWORD: curEncrypted.toString(),
          PASSWORD: encrypted.toString(),
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };
        http
          .post("api/profile/ProfileChangePassword", data, { timeout: 5000 })
          .then((response) => {
            if (response.data.VALID === "CURRENT_PASSWORD" || response.data.VALID === "PASSWORD_REPEAT" || response.data.VALID === "PASSWORD_INVALID") {
              setEditData(prevState => ({
                ...prevState,
                ERROR_MSG: response.data.ERROR_MSG,
              }))
            }
            else {
              toast.success("Change password successfully.");
		          hideModal();
							props.onReload();
            }
          })
          .catch((err) => {
            toast.error("Failed to reset password. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to reset password. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  };

  function furtherValidateInput(id, val) {
    if (id === "CONFIRM_PASSWORD") {
      var PASSWORD = editData.PASSWORD;
      if (PASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: ("Please confirm the passwords are match."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: (""),
        }));
      }
    } else {
      var CPASSWORD = editData.CONFIRM_PASSWORD;
      if (CPASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: ("Please confirm the passwords are match."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: (""),
        }));
      }
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (name + " could not be empty."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (""),
        }));
        furtherValidateInput(id, val);
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
		  setHasChanges(true);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Change Password</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
						<label className={classes.colFormLabel}>Current Password*</label>
						<div className={classes.modalPopupItem}>
							<div className="input-container">
								<input
									className="form-control"
									ref={userPasswordInputRef}
									type={curVisible ? 'text' : 'password'}
									id="CURRENT_PASSWORD"
									value={editData.CURRENT_PASSWORD}
									name="Current Password"
									onChange={inputRequiredHandler}
                  onKeyDown={onKeyDown}
								/>
								<div className="icon-container">
									{curVisible ? (
										<FaRegEye 
											className='icon' 
											onClick={toggleCurPasswordVisibility}
										/>
									) : (
										<FaEyeSlash
											className='icon' 
											onClick={toggleCurPasswordVisibility}
										/>
									)}
								</div>
							</div>	

							{inputError.CURRENT_PASSWORD !== "" && (
								<div className={classes.invalidMessage}>{inputError.CURRENT_PASSWORD}</div>
							)}
						</div>
					</div>

          <div className="form-group">
						<label className={classes.colFormLabel}>Password*</label>
						<div className={classes.modalPopupItem}>
							<div className="input-container">
								<input
									className="form-control"
									ref={userPasswordInputRef}
									type={newVisible ? 'text' : 'password'}
									id="PASSWORD"
									value={editData.PASSWORD}
									name="Password"
									onChange={inputRequiredHandler}
                  onKeyDown={onKeyDown}
								/>
								<div className="icon-container">
									{newVisible ? (
										<FaRegEye 
											className='icon' 
											onClick={toggleNewPasswordVisibility}
										/>
									) : (
										<FaEyeSlash
											className='icon' 
											onClick={toggleNewPasswordVisibility}
										/>
									)}
								</div>
							</div>	

							{inputError.PASSWORD !== "" && (
								<div className={classes.invalidMessage}>{inputError.PASSWORD}</div>
							)}
						</div>
					</div>

          <div className="form-group">
						<label className={classes.colFormLabel}>Confirm Password*</label>
						<div className={classes.modalPopupItem}>
							<div className="input-container">
								<input
									className="form-control"
									ref={userCPasswordInputRef}
									type={reVisible ? 'text' : 'password'}
									id="CONFIRM_PASSWORD"
									value={editData.CONFIRM_PASSWORD}
									name="Confirm Password"
									onChange={inputRequiredHandler}
                  onKeyDown={onKeyDown}
								/>
								<div className="icon-container">
									{reVisible ? (
										<FaRegEye 
											className='icon' 
											onClick={toggleRePasswordVisibility}
										/>
									) : (
										<FaEyeSlash
											className='icon' 
											onClick={toggleRePasswordVisibility}
										/>
									)}
								</div>
							</div>	

							{inputError.CONFIRM_PASSWORD !== "" && (
								<div className={classes.invalidMessage}>{inputError.CONFIRM_PASSWORD}</div>
							)}
						</div>
					</div>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
          <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>

            {editData.ERROR_MSG && editData.ERROR_MSG.split('\n').map((line, index) => (
              <p key={index} style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{line}</p>
            ))}
            {/* <p style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{editData.ERROR_MSG}</p> */}
          </div>
        </Modal.Footer>
      </Modal>

			{/* Confirmation Modal */}
			<BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
        prop="Confirm Navigation"
      >
        Are you sure you want to go back? Your changes may be lost.
      </BackModal>

			<ConfirmModal
				show={showConfirmModal}
				onHide={handleConfirmModalClose}
				onConfirm={handleConfirmModal}
				prop="Confirm to change password"
			>
				Are you sure you want to change password?
			</ConfirmModal>
    </>
  );
};

export default ProfileChangePassword;